// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.search-bar {
  width: 50%;
}

.search-input-wrapper {
  position: relative;
  display: flex;
  align-items: center;
}

.search-icon {
  position: absolute;
  left: 16px;
  width: 20px;
  height: 20px;
  color: #6B7280;
}

.search-input {
  width: 100%;
  padding: 12px 16px 12px 48px;
  border: 1px solid #2C3948;
  border-radius: 50px;
  font-size: 1.6rem;
  font-family: 'Inter', sans-serif;
  outline: none;
  transition: all 0.2s ease;
}

.search-input:focus {
  border-color: #DA7027;
  box-shadow: 0 0 0 2px rgba(218, 112, 39, 0.1);
}

.search-input::placeholder {
  color: #2C3948;
  font-size: 1.8rem;
  font-weight: 400;
}

.search-icon {
    width: 28px;
    height: 28px;
}

.search-loading {
  width: 20px;
  height: 20px;
  position: absolute;
  left: 16px;
  border: 2px solid #f3f3f3;
  border-top: 2px solid #DA7027;
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}`, "",{"version":3,"sources":["webpack://./src/composants/SearchBar/SearchBar.css"],"names":[],"mappings":"AAAA;EACE,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,4BAA4B;EAC5B,yBAAyB;EACzB,mBAAmB;EACnB,iBAAiB;EACjB,gCAAgC;EAChC,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,UAAU;EACV,yBAAyB;EACzB,6BAA6B;EAC7B,kBAAkB;EAClB,kCAAkC;AACpC;;AAEA;EACE,KAAK,uBAAuB,EAAE;EAC9B,OAAO,yBAAyB,EAAE;AACpC","sourcesContent":[".search-bar {\r\n  width: 50%;\r\n}\r\n\r\n.search-input-wrapper {\r\n  position: relative;\r\n  display: flex;\r\n  align-items: center;\r\n}\r\n\r\n.search-icon {\r\n  position: absolute;\r\n  left: 16px;\r\n  width: 20px;\r\n  height: 20px;\r\n  color: #6B7280;\r\n}\r\n\r\n.search-input {\r\n  width: 100%;\r\n  padding: 12px 16px 12px 48px;\r\n  border: 1px solid #2C3948;\r\n  border-radius: 50px;\r\n  font-size: 1.6rem;\r\n  font-family: 'Inter', sans-serif;\r\n  outline: none;\r\n  transition: all 0.2s ease;\r\n}\r\n\r\n.search-input:focus {\r\n  border-color: #DA7027;\r\n  box-shadow: 0 0 0 2px rgba(218, 112, 39, 0.1);\r\n}\r\n\r\n.search-input::placeholder {\r\n  color: #2C3948;\r\n  font-size: 1.8rem;\r\n  font-weight: 400;\r\n}\r\n\r\n.search-icon {\r\n    width: 28px;\r\n    height: 28px;\r\n}\r\n\r\n.search-loading {\r\n  width: 20px;\r\n  height: 20px;\r\n  position: absolute;\r\n  left: 16px;\r\n  border: 2px solid #f3f3f3;\r\n  border-top: 2px solid #DA7027;\r\n  border-radius: 50%;\r\n  animation: spin 1s linear infinite;\r\n}\r\n\r\n@keyframes spin {\r\n  0% { transform: rotate(0deg); }\r\n  100% { transform: rotate(360deg); }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
